import * as angular from "angular";
import {IController} from 'angular';

export class bringozSelectFilterCtrl implements IController {

  type: any;
  selectedId: any;
  branchIds: any;
  carrierIds: any;
  billingAccountIds: any;
  options: any;
  pageName: string;
  ngPlaceholder: any;
  noUnderline: any;
  excludeIds: any;
  rowLimit: any;
  isDisabled: any;
  hideDisplay?: boolean;
  customSelectIcon: string;
  optionsPrefix: string;
  onChange: Function;

  /* @ngInject */
  constructor(private $mdPanel) {}

  $onInit() {
  };

  $onChanges(changes) {

  };


  onShowPanel($event) {
    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.bringoz-selection-button')
      .withAnimation(this.$mdPanel.animation.FADE);

    const typeRef = this.type;
    const selectedIdRef = this.selectedId;
    const branchIdsRef = this.branchIds;
    const billingAccountIdsRef = this.billingAccountIds;
    const carrierIdsRef = this.carrierIds;
    const pageNameRef = this.pageName;
    const optionsRef = this.options;
    const ngPlaceholderRef = this.ngPlaceholder;
    const excludeIdsRef = this.excludeIds;
    const optionsPrefixRef = this.optionsPrefix;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<bringoz-select-filter-panel ' +
        'type="ctrl.typeRef" ' +
        'selected-id="ctrl.selectedIdRef" ' +
        'branch-ids="ctrl.branchIdsRef" ' +
        'query-map="ctrl.queryMapRef" ' +
        'options="ctrl.optionsRef" ' +
        'ng-placeholder="ctrl.ngPlaceholderRef" ' +
        'options-prefix="{{ctrl.optionsPrefixRef}}" ' +
        'exclude-ids="ctrl.excludeIdsRef" ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        'ng-placeholder="Search Branches">' +
        '</bringoz-select-filter-panel>',
      controller: function () {
        this.typeRef = typeRef;
        this.selectedIdRef = selectedIdRef;
        this.branchIdsRef = branchIdsRef;
        this.billingAccountIdsRef = billingAccountIdsRef;
        this.carrierIdsRef = carrierIdsRef;
        this.optionsRef = optionsRef;
        this.ngPlaceholderRef = ngPlaceholderRef;
        this.excludeIdsRef = excludeIdsRef;
        this.queryMapRef = {
          billingAccountIds: billingAccountIdsRef,
          pageName: pageNameRef
        };
        this.optionsPrefixRef = optionsPrefixRef;
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, selectedId, selectedItem?) => {
        panel.destroy();
        if (selectedId === 'clickOutsideToClose' || selectedId === 'escapeToClose') {
          return;
        } else {
          this.onChange({selectedId: selectedId, selectedItem: selectedItem});
        }
      }
    };

    this.$mdPanel.open(config);
  }

  onResetFilter() {
    this.onChange({selectedId: undefined});
  }


}

angular
  .module('bringoz.admin.commons')
  .component('bringozSelectFilter', {
    bindings: {
      type: '@',
      selectedId: '<?',
      branchIds: '<?', // Only for two factor select
      carrierIds: '<?', // Only for two factor select
      options: '<?',
      pageName: '<?',
      billingAccountIds: '<?',
      ngPlaceholder: '@?',
      excludeIds: '<?',
      rowLimit: '<?',
      isDisabled: '<?',
      hideDisplay: '<?',
      customSelectIcon: '@?',
      optionsPrefix: '@?',
      onChange: '&'
    },
    template: require('./bringoz-select-filter.html').default,
    controller: bringozSelectFilterCtrl
  });
